import { useState } from 'react'
import { Dialog } from 'radix-ui'
import { useCancelContract } from '../hooks'

type Props = {
  contractId: number
  open: boolean
  onClose: () => void
}

export function CancelContractDialog({ contractId, open, onClose }: Props) {
  const [reason, setReason] = useState('')
  const mutation = useCancelContract(contractId)

  const submit = () => {
    if (!reason.trim()) return
    mutation.mutate({ reason }, { onSuccess: () => { setReason(''); onClose() } })
  }

  return (
    <Dialog.Root open={open} onOpenChange={o => { if (!o) onClose() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-5 w-[420px] shadow-xl">
          <Dialog.Title className="text-base font-semibold">Anulowanie umowy</Dialog.Title>
          <Dialog.Description className="text-sm text-slate-600 mt-1">
            Operacja nieodwracalna. Podaj powód anulowania.
          </Dialog.Description>

          <textarea
            className="w-full border rounded p-2 text-sm mt-3 min-h-[80px]"
            placeholder="Powód..."
            value={reason}
            onChange={e => setReason(e.target.value)}
            disabled={mutation.isPending}
          />

          {mutation.isError && <p className="text-red-600 text-xs mt-2">Nie udało się anulować umowy.</p>}

          <div className="flex justify-end gap-2 mt-4">
            <button type="button" onClick={onClose} className="px-3 py-1.5 border rounded" disabled={mutation.isPending}>
              Wróć
            </button>
            <button
              type="button"
              onClick={submit}
              disabled={!reason.trim() || mutation.isPending}
              className="px-3 py-1.5 bg-red-600 text-white rounded disabled:opacity-50"
            >
              {mutation.isPending ? 'Anulowanie...' : 'Anuluj umowę'}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
